<div class="avs-map-consent p-1 d-flex flex-column justify-content-center align-items-center text-center">
    <img class= "opacity-50" src="assets/icons/map-pin-solid.svg" height="40">
    <h5 class="fw-semibold">Kartendarstellung mit Goole Maps</h5>
    <p>
        Beim Laden der Goggle Karte werden Daten, u.a. ihre IP Adresse an Google Server in die USA übertragen. 
        Weitere Informationen finden Sie in unserer <a routerLink="/privacy">Datenschutzerklärung</a>.</p>
    <p class=""> Stimmen Sie der Nutzung ihrer Daten für diesen Zweck zu?</p>
    <button class="btn btn-sm btn-outline-danger rounded-0 me-2" (click)="onAcceptButtonClicked()">
        Zustimmen und Karte laden
    </button>
    <small class="mt-2">
        Die Zustimmung wird nur im Browser gespeichert und kann jederzeit widerrufen werden.
    </small>
</div>

